import * as React from 'react'
import { MatchPair } from '../MatchPair'
import { BillToMatchButton } from '../BillToMatchDrawer'
import { MatchProps } from '../typings'
import { MatchClasses, State, Dispatch } from '../hooks'
import { ValidatedLocation } from '../../typings'

type Props = MatchProps & {
  styles: MatchClasses
  state: State
  dispatch: Dispatch
  location: ValidatedLocation
}

export const BillToLocation: React.FC<Props> = (props) => {
  const {
    state: { externalBillTo },
  } = props

  return (
    <>
      {!!externalBillTo && <BillToMatchButton {...props} />}
      <MatchPair {...props} />
    </>
  )
}
BillToLocation.displayName = 'BillToLocation'
